"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";
import {
	setRuntimeTranslator,
	type RuntimeMessageKey,
	type RuntimeMessageValues,
} from "@/i18n/runtime-messages";

export function RuntimeMessages() {
	const t = useTranslations("RuntimeErrors");

	useEffect(
		() =>
			setRuntimeTranslator({
				translator: ({
					key,
					values,
				}: {
					key: RuntimeMessageKey;
					values?: RuntimeMessageValues;
				}) => t(key, values),
			}),
		[t],
	);

	return null;
}
